import { render } from "./BaseAccountDesktopView.vue?vue&type=template&id=2addf084&scoped=true"
import script from "./BaseAccountDesktopView.vue?vue&type=script&lang=js"
export * from "./BaseAccountDesktopView.vue?vue&type=script&lang=js"

import "./BaseAccountDesktopView.vue?vue&type=style&index=0&id=2addf084&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Dj_Volodya\\PycharmProjects\\7scalesProjects\\GeoffBanks\\geoff-banks-mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2addf084"]])

export default __exports__